<template>
    <div></div>
</template>

<script>
import { setCookie } from '@/services/cookie-service';
import { KEYS } from '@/utils/constants';
import { getParameterByName } from '@/utils';

import { getMagicLinkToken } from '@/services/api/magic-link';

import { mapActions } from 'vuex';
export default {
    name: 'MagicLink',
    async created () {
        try {
            let token = this.getToken();

            token = await this.magicLinkAuthentication(token);
            await this.setUserInformation({ key: token });

            // setando o cookie como true caso ele venha de e-mail ou modo deus
            this.setCookieAccepetd();
            const redirect = this.getRedirect();
            if (redirect) {
                this.$router.push(redirect);
            } else {
                this.$router.push({ name: 'Home' });
            }
        } catch (error) {
            this.$router.push({ name: 'LandingPage' });
        }
    },
    methods: {
        ...mapActions('user', ['setUserInformation']),
        setCookieAccepetd () {
            const days = 720;
            setCookie(KEYS.ACCEPETD_COOKIES, true, days);
        },
        async magicLinkAuthentication (tk) {
            try {
                const { token } = await getMagicLinkToken(`?sesame=${tk}`);
                setCookie(KEYS.CREDENTIALS_TOKEN, token);
                return token;
            } catch (error) {
                console.error(error);
            }
        },
        getToken () {
            return getParameterByName('sesame');
        },
        getRedirect () {
            return getParameterByName('redirect');
        }
    }
};
</script>

<style lang="scss" scoped>
</style>